import apiService from '../ApiService';

export type AdminPrivacyRequest = {
  id: number;
  user_id: number | null;
  request_type: string;
  status: string;
  has_contact_email: boolean;
  details: Record<string, unknown>;
  created_at: string;
  closed_at: string | null;
};

const ENDPOINT = '/admin/privacy_requests.php';

export async function adminListPrivacyRequests(status?: string): Promise<AdminPrivacyRequest[]> {
  const qs = new URLSearchParams();
  if (status) qs.set('status', status);
  const suffix = qs.toString() ? `?${qs}` : '';
  const response = await apiService.makeRequest<{ requests?: AdminPrivacyRequest[] }>(
    `${apiService.getAdminEndpoint(ENDPOINT)}${suffix}`,
    { headers: apiService.getAuthHeaders() }
  );
  return response.data?.requests ?? [];
}

export async function adminUpdatePrivacyRequestStatus(
  id: number,
  status: 'open' | 'in_progress' | 'closed'
): Promise<void> {
  await apiService.makeRequest(apiService.getAdminEndpoint(ENDPOINT), {
    method: 'POST',
    body: JSON.stringify({ id, status }),
    headers: apiService.getAuthHeaders(),
  });
}
